let store = null;
/** Called once at app bootstrap to wire the environment's storage handler. */
export function registerMediaStore(handler) {
    store = handler;
}
export function getMediaStore() {
    if (!store) {
        throw new Error('media-library: no store registered — call registerMediaStore() at bootstrap');
    }
    return store;
}
//# sourceMappingURL=store.js.map